"use strict";
const JOB_DATA_TYPES = {
    ACCOUNT: 'account',
    USER: 'user',
    COLLECTION: 'account_collection',
    USAGE: 'usage',
    ACCOUNT_USER: 'account_user',
    USAGE_AGGREGATIONS: 'provided_daily_account_usage_aggregation',
    TOTANGO_USER: 'totango_user',
    HISTORICAL_CLICK_STREAM: 'historical_usage_clickstream',
    HISTORICAL_ACCOUNTS: 'historical_account',
    HISTORICAL_USER_USAGE: 'historical_user_usage',
    HISTORICAL_ACCOUNT_USAGE: 'historical_account_usage',
    ACCOUNT_ASSIGNMENT: 'account_assignment',
    TASK: 'task',
    TASK_OUT: 'task_out',
    TOUCHPOINT: 'touchpoint',
    TOUCHPOINT_OUT: 'touchpoint_out',
    INSIGHTS_OUT: 'account_insights_out',
    CAMPAIGN_TOUCH_OUT: 'campaign_touch_out',
    ACCOUNT_USER_OUT: 'account_user_out',
    ACCOUNT_FOREIGN_KEY: 'account_foreign_key',
    OPPORTUNITY: 'opportunity',
    OPPORTUNITY_OUT: 'opportunity_out',
    OPPORTUNITY_TEAM_MEMBER: 'opportunity_team_member',
    ACCOUNT_EXPORT: 'account_export',
    USER_EXPORT: 'user_export',
    COLLECTION_EXPORT: 'account_collection_export',
    TASK_COLLECTION_EXPORT: 'task_collection_export',
    TOUCHPOINT_COLLECTION_EXPORT: 'touchpoint_collection_export',
    OPPORTUNITY_EXPORT: 'opportunity_export',
};
const CONNECTOR_TYPES = {
    DROPBOX: 'dropbox',
    MINIO: 'minio',
    S3: 's3',
    SFTP: 'sftp',
    SFTP_KEY_FILE: 'sftp_keyFile',
    LOCAL: 's3_local',
    SALESFORCE: 'salesforce',
    SALESFORCE_SOQL: 'salesforce_soql',
    MSDYNAMICS: 'ms-dynamics',
    REDSHIFT: 'redshift_jdbc',
    MYSQL: 'mysql_jdbc',
    POSTGRESQL: 'postgres_jdbc',
    MSSQL: 'mssql_jdbc',
    SNOWFLAKE: 'snowflake_jdbc',
    GCP: 'gcp_storage_s3',
    HUBSPOT: 'hubspot',
    GOOGLE_DRIVE: 'google_drive',
    GOOGLE_BIG_QUERY: 'gcp_bigquery',
    TOTANGO_USAGE: 'totango_usage',
    JIRA_SERVICE_DESK: 'jira_sd',
    JIRA: 'jira',
    ZUORA: 'zuora_sql',
    INTERCOM: 'intercom',
    ZOHO: 'zoho_crm',
    PENDO: 'pendo',
    MIXPANEL: 'mixpanel',
    DATABRICKS: 'databricks_jdbc',
    CHORUS: 'chorus',
    GONG: 'gong',
    GOOGLE_CALENDAR: 'google_calendar',
    GOOGLE_MAIL: 'google_mail',
    OUTLOOK_CALENDAR: 'outlook_calendar',
    MS_TEAMS: 'ms_teams',
    ZOOM_INFO: 'zoom_info',
    ORACLE: 'oracle_jdbc',
};
const STEPS_ENUM = {
    START: 'start',
    PROCESS: 'process',
    END: 'end',
};
const STATUS_ENUM = {
    FAILURE: 'failure',
    PARTIAL_SUCCESS: 'partial',
    SUCCESS: 'success',
};
const FAILURE_REASON = {
    SKIPPED: 'skipped',
    EMPTY_FILE: 'empty',
};
const CONTENT_TYPE = {
    JSON: 'application/json',
    FORM: 'application/x-www-form-urlencoded',
};
const SOURCE_ID = {
    LOCAL_FILE: 'generic',
    SFTP: 'sftp',
    DROPBOX: 'dropbox',
    GOOD_DATA: 'gooddata',
    S3: 's3',
    MINIO: 'minio',
};
const SOURCE_TYPES = {
    IHDF: 'ihdf',
    CSVFILE: 'csv_file',
    QUERY_BASED: 'query_based',
    DATASTORE: 'datastore',
};
const ERROR_CODES = {
    EMPTY: '2052',
    SKIPPED: '2053',
};
const JOBS_TO_EXECUTE = [
    JOB_DATA_TYPES.ACCOUNT,
    JOB_DATA_TYPES.USER,
    JOB_DATA_TYPES.COLLECTION,
    JOB_DATA_TYPES.ACCOUNT_USER,
    JOB_DATA_TYPES.TOTANGO_USER,
    JOB_DATA_TYPES.TASK,
    JOB_DATA_TYPES.TASK_OUT,
    JOB_DATA_TYPES.TOUCHPOINT,
    JOB_DATA_TYPES.TOUCHPOINT_OUT,
    JOB_DATA_TYPES.INSIGHTS_OUT,
    JOB_DATA_TYPES.CAMPAIGN_TOUCH_OUT,
    JOB_DATA_TYPES.ACCOUNT_USER_OUT,
    JOB_DATA_TYPES.ACCOUNT_FOREIGN_KEY,
    JOB_DATA_TYPES.OPPORTUNITY,
    JOB_DATA_TYPES.OPPORTUNITY_OUT,
    JOB_DATA_TYPES.ACCOUNT_EXPORT,
    JOB_DATA_TYPES.USER_EXPORT,
    JOB_DATA_TYPES.COLLECTION_EXPORT,
    JOB_DATA_TYPES.TASK_COLLECTION_EXPORT,
    JOB_DATA_TYPES.TOUCHPOINT_COLLECTION_EXPORT,
    JOB_DATA_TYPES.OPPORTUNITY_EXPORT,
];
module.exports = {
    JOB_DATA_TYPES,
    JOBS_TO_EXECUTE,
    CONNECTOR_TYPES,
    STEPS_ENUM,
    STATUS_ENUM,
    FAILURE_REASON,
    CONTENT_TYPE,
    SOURCE_ID,
    SOURCE_TYPES,
    ERROR_CODES,
};
//# sourceMappingURL=consts.js.map